import Trans from 'next-translate/Trans';
import { FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { PointBackValue } from '../constant';
type IProps = {
  className?: string;
  label?: string;
  size?: 'small' | 'normal' | 'mini';
  theme: 'black' | 'light';
};

const _PointsBackLabel: FC<IProps> = ({ className, label, theme, size = 'normal' }) => {
  return (
    <div
      data-testid="wid-group-order-points-back-label"
      className={twMerge(
        'rounded-200 py-0.5 px-1.5 w-fit box-border',
        'enki-body-2xs-medium',
        'flex items-center',
        theme === 'black' ? 'bg-[#06CB6C] text-surface-100-fg-default' : 'bg-[#018260] text-reserved-true-white',
        size === 'small' ? '!text-[10px] !leading-none font-medium' : '',
        size === 'mini' ? 'enki-body-3xs' : '',
        className
      )}
      style={{ height: size === 'mini' ? '18px' : 'auto' }}>
      {!!label ? (
        label
      ) : (
        <Trans
          i18nKey="groupOrder:points_back"
          values={{
            pointValue: PointBackValue
          }}
        />
      )}
    </div>
  );
};

const PointsBackLabel = memo(_PointsBackLabel);

export default PointsBackLabel;
